import { render, staticRenderFns } from "./profile-menu.component.vue?vue&type=template&id=3008562a&scoped=true&"
import script from "./profile-menu.component.vue?vue&type=script&lang=ts&"
export * from "./profile-menu.component.vue?vue&type=script&lang=ts&"
import style0 from "./profile-menu.component.vue?vue&type=style&index=0&id=3008562a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3008562a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
